import { render, staticRenderFns } from "./Menumanage.vue?vue&type=template&id=3693ba7d&scoped=true&"
import script from "./Menumanage.vue?vue&type=script&lang=js&"
export * from "./Menumanage.vue?vue&type=script&lang=js&"
import style0 from "./Menumanage.vue?vue&type=style&index=0&id=3693ba7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3693ba7d",
  null
  
)

export default component.exports